import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  FileText,
  MessageSquare,
  ShoppingCart,
  Settings,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { key: '/dashboard', label: 'Thống kê', icon: LayoutDashboard },
  { key: '/orders', label: 'Đơn hàng', icon: FileText },
  { key: '/chat', label: 'Hội thoại', icon: MessageSquare },
  { key: '/products', label: 'Sản phẩm', icon: ShoppingCart },
  { key: '/setting', label: 'Cài đặt', icon: Settings },
];

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  // Hide bottom nav when inside specific active chat views or print orders or auth
  const isIndividualChat = pathname.startsWith('/chat/') && pathname !== '/chat';
  const isPrint = pathname.startsWith('/print');
  const isAuth = pathname === '/login' || pathname === '/register';

  if (isIndividualChat || isPrint || isAuth) {
    return null;
  }

  return (
    <nav
      aria-label="Mobile navigation"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-t border-slate-200 dark:border-slate-800 pb-[env(safe-area-inset-bottom,0px)] shadow-[0_-2px_10px_rgba(0,0,0,0.05)] dark:shadow-[0_-2px_10px_rgba(0,0,0,0.3)] transition-all"
    >
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto px-1">
        {navItems.map((item) => {
          const isActive =
            pathname === item.key ||
            (item.key !== '/' && pathname.startsWith(item.key));
          const Icon = item.icon;

          return (
            <button
              key={item.key}
              type="button"
              onClick={() => {
                if (pathname !== item.key) {
                  navigate(item.key);
                }
              }}
              className={cn(
                'flex flex-1 flex-col items-center justify-center py-1 px-1 h-full rounded-lg transition-all duration-200 active:scale-95 touch-manipulation cursor-pointer',
                isActive
                  ? 'text-blue-600 dark:text-blue-400 font-semibold'
                  : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'
              )}
            >
              <div className="relative flex items-center justify-center">
                <Icon
                  className={cn(
                    'h-5 w-5 transition-transform duration-200',
                    isActive && 'scale-110 text-blue-600 dark:text-blue-400'
                  )}
                />
              </div>
              <span
                className={cn(
                  'text-[10px] mt-0.5 tracking-tight line-clamp-1',
                  isActive ? 'font-semibold text-blue-600 dark:text-blue-400' : 'font-normal'
                )}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
